<ng-container *ngIf="viewModel$ | async as vm">
  <app-sidebar-card (click)="toggle(expander)">
    <div class="is-flex gap-8 is-align-center">
      <app-sidebar-card-icon
        [name]="RoomsAssets[vm.room.type].icon"
      ></app-sidebar-card-icon>
      <app-sidebar-card-label>{{ vm.room.name }}</app-sidebar-card-label>
    </div>

    <div class="is-flex gap-16 is-align-center">
      <div class="is-flex gap-4">
        <app-boiler-icon></app-boiler-icon>
        <div *ngIf="vm.displayTemperature" class="is-flex text-14 is-family-semiBold">
          <app-text>
            {{
              vm.temperatureUnreachable
                ? "--"
                : (getTemperatureDisplay(vm.temperatureModule, vm.room)
                  | toUserUnit : EnumMeasureTypes.TEMPERATURE
                  | toDisplayValue : EnumMeasureTypes.TEMPERATURE)
            }}
          </app-text>
          <app-text
            unit
            [measureType]="EnumMeasureTypes.TEMPERATURE"
          ></app-text>
        </div>
      </div>
      <app-sidebar-card-expand
        [id]="room.id"
        #expander
      ></app-sidebar-card-expand>
    </div>
  </app-sidebar-card>

  <div [@expand]="expander.open ? 'open' : 'close'">
    <app-outdoor-air-quality></app-outdoor-air-quality>
    <app-indoor-air-quality></app-indoor-air-quality>
    <app-room-temperature></app-room-temperature>
    <app-room-humidity></app-room-humidity>
    <app-room-pressure></app-room-pressure>
    <app-room-co2></app-room-co2>
    <app-room-noise></app-room-noise>
    <app-room-wind></app-room-wind>
    <app-room-rain></app-room-rain>
  </div>
</ng-container>
